import React, { useEffect } from "react"
import { Link } from "gatsby"
import { useQuery, gql } from "@apollo/client"
import { SearchResultsContainer } from "./RecyclopediaResults.styles"
import Card from "../Card/Card"

const GET_RESULTS = gql`
  query searchQuery($searchTerm: String) {
    contentNodes(where: { search: $searchTerm }, first: 10000) {
      nodes {
        contentTypeName
        ... on Recyclopedia {
          id
          title
          slug
          content
        }
      }
    }
  }
`
const SearchResults = ({
  searchTerm,
  resultCount,
  setResultCount,
  filters,
  results,
  setResults,
}) => {
  const { data, loading, error } = useQuery(GET_RESULTS, {
    variables: { searchTerm },
  })

  useEffect(() => {
    if (data && data.contentNodes && data.contentNodes.nodes) {
      //shorten for repeated referencing
      let nodes = data.contentNodes.nodes

      //use to determine whether or not to apply filters
      let filtersApplied = false

      if (filters.length > 0) {
        filtersApplied = true
      }

      let resultCount = 0

      let finalResultsTemp = []

      //loop through and remove based on filters and remove ActionMonitorAction types
      for (let i = 0; i < nodes.length; i++) {
        //remove action monitor action type
        if (nodes[i].__typename === "Recyclopedia") {
          if (
            nodes[i].__typename !== "ActionMonitorAction" &&
            nodes[i].__typename !== "Post" &&
            !filtersApplied
          ) {
            resultCount++
            finalResultsTemp.push(nodes[i])
          } else if (
            nodes[i].__typename !== "ActionMonitorAction" &&
            nodes[i].__typename !== "Post" &&
            filtersApplied &&
            filters.includes(nodes[i].__typename)
          ) {
            resultCount++
            finalResultsTemp.push(nodes[i])
          }
        }
      }

      //set result count for display
      setResultCount(resultCount)
      setResults(finalResultsTemp)
    } else {
      //if nothing, reset result count
      setResultCount(0)
    }
  }, [data, filters, setResultCount, setResults])

  if (loading)
    return (
      <SearchResultsContainer>
        <div className="innerContainer">
          <section className="search-results">
            <Card
              padding="1.5rem"
              content={
                <>
                  <p className="secondaryLink">Searching for {searchTerm}...</p>
                </>
              }
            ></Card>
          </section>
        </div>
      </SearchResultsContainer>
    )
  if (error)
    return (
      <SearchResultsContainer>
        <div className="innerContainer">
          <section className="search-results">
            <Card
              padding="1.5rem"
              content={
                <>
                  <p className="secondaryLink">Error - {error.message}</p>
                </>
              }
            ></Card>
          </section>
        </div>
      </SearchResultsContainer>
    )
  return (
    <SearchResultsContainer>
      <div className="innerContainer">
        <section className="search-results">
          <ul>
            {data && data.contentNodes && data.contentNodes.nodes ? (
              <p className="secondaryLabelMax">
                {resultCount} Result{resultCount !== 1 ? "s" : null} Found
              </p>
            ) : (
              <p>0 Results Found</p>
            )}
            {results.length > 0 ? (
              results.map(result => (
                <li>
                  {result.__typename === "Recyclopedia" && (
                    <Card
                      padding="1.5rem"
                      content={
                        <>
                          {/* <div className="cardContainer">
                            <Icon category={result.__typename}></Icon>
                            <span className="secondaryLink">
                              {result.__typename}
                            </span>
                          </div> */}
                          <span className="headline darkBlueTxt">
                            <Link to={"/" + result.slug}>{result.title}</Link>
                            {/* <Icon category="Chevron Right"></Icon> */}
                          </span>
                          <div
                            className="container"
                            dangerouslySetInnerHTML={{ __html: result.content }}
                          />
                        </>
                      }
                      width="100%"
                    ></Card>
                  )}
                </li>
              ))
            ) : (
              <li>
                <Card
                  padding="1.5rem"
                  content={
                    <>
                      <p className="secondaryLink">No Results Found</p>
                    </>
                  }
                ></Card>
              </li>
            )}
          </ul>
        </section>
      </div>
    </SearchResultsContainer>
  )
}
export default SearchResults
